<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component class="kendo-pointer-default"
        :spanish="spanish"
        :dataResult='kendo.dataResult'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @datastatechange='dataStateChange'
        @columnreorder='columnReorder'
        @rowclick='openPath'
        @columnssubmit='onColumnsSubmit'
        @sortchange='sortChange'
        @filterchange='filterChange'
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="accionesSedesAdminDynamic !== null && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesSedesAdminDynamic" :key="action.id">
              <base-button-item-list theme="dark"  @click="executeAction(action)">
                <base-icon :name="action.icon" class="mr-2" :ariaHidden="true"/>
                {{ action.name }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode="primary" v-if="role === 'Administrador'" :text="labelBtnLinkPgns" icon="link" @click="onClicktoggleDialogLink" :loading="isGeneralLoading"/>
          <!-- <base-button-responsive mode="primary" :text="$t('locations.new_location')" icon="plus" @click="goToNewLocation" :loading="isGeneralLoading"/> -->
        </template>
      </base-footer>
      <template-link-Companies-dialog 
        :title="labelBtnLinkPgns"
        :dialogOpen="linkToCompaniesDialog" 
        :clientId="this.$route.params.id" 
        @toggleDialog="toggleDialogLink" 
        @applyDialog="applyLinkCompaniesHandler" />
      <template-link-Companies-dialog 
        :title="labelBtnLinkPgn"
        :dialogOpen="linkPgnToCompaniesDialog" 
        :clientId="this.$route.params.id" 
        @toggleDialog="toggleDialogLinkPgn" 
        @applyDialog="applyLinkPgnCompaniesHandler" />
      <template-link-Companies-dialog 
        :title="labelBtnUnlinkPgn"
        :dialogOpen="unlinkPgnToCompaniesDialog" 
        :clientId="this.$route.params.id" 
        @toggleDialog="toggleDialogUnlinkPgn" 
        @applyDialog="applyUnlinkPgnCompaniesHandler" />      
      <location-grouping-dialog 
        :dialogOpen="showModalGrouping" 
        @toggleDialog="toggleModalGrouping" 
        @applyDialog="applyModalGrouping"
        header="Vincular a agrupación" 
        headerValue="Nombre de la agrupación" 
        />
      <link-agencies-dialog 
        :title="$t('companies.exclude_organismos')" 
        :dialogOpen="excludeAgenciesDialog" 
        @toggleDialog="toggleExcludeAgenciesDialogs" 
        @applyDialog="applyExcludeAgenciesHandler" 
        :agenciesBase="agenciesBaseTemp"
        />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/ConfigLocationsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import LocationGroupingDialog from '@/components/LocationGroupingDialog.vue'
import { getSedesPag } from '@/services/app/getSedesPag'
import { updateAgenciesExclusions } from '@/services/clients/updateAgenciesExclusions'

import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
// import { saveExcel } from '@progress/kendo-vue-excel-export'
import { getSedesExcel } from '@/services/app/getSedesExcel'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import LinkAgenciesDialog from '@/components/LinkAgenciesDialog.vue'
import { getValoresDefectoByClientPag } from '@/services/clients/getValoresDefectoByClientPag'
import { getValoresDefectoByClientExcel } from '@/services/clients/getValoresDefectoByClientExcel'
import { updateCompaniesFromValoresDefecto } from '@/services/companies/updateCompaniesFromValoresDefecto'
import { linkPgnToCompaniesFromValoresDefecto } from '@/services/companies/linkPgnToCompaniesFromValoresDefecto'
import { unlinkPgnToCompaniesFromValoresDefecto } from '@/services/companies/unlinkPgnToCompaniesFromValoresDefecto'
import TemplateLinkCompaniesDialog from '@/components/TemplateLinkCompaniesDialog.vue'

import { linkGroupingLocationsName } from '@/services/configurations/grouping/linkGroupingLocationsName'

export default {
  name: 'list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    LinkAgenciesDialog,
    TemplateLinkCompaniesDialog,
    LocationGroupingDialog,
  },
  data: function () {
    return {
      idVista: 5,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      showModalGrouping: false,
      linkToCompaniesDialog: false,
      linkPgnToCompaniesDialog: false,
      unlinkPgnToCompaniesDialog: false,
      excludeAgenciesDialog: false,
      loadingExcel: false,
      spanish: true,
      header: {
        title: i18n.t('app.locations_hired'),
        icon: 'config',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'locations',
      filterPanel: false,
      showAllRows: true,
      tableData: [],
      accionesSedesAdmin: [
        {
          id: 1,
          name: this.$i18n.t('app.agency_edit'),
          icon: 'exclude-agencies',
        },
        {
          id: 12,
          name: 'Vincular a agrupación',
          icon: 'groupingadd',
        },
        {
          id: 100,
          name: this.$i18n.t('configurations.link_pgn_to_companies'),
          icon: 'link'
        },
        {
          id: 101,
          name: this.$i18n.t('configurations.unlink_pgn_to_companies'),
          icon: 'unlink'
        },
      ],
      selectedField: 'selected',
      selected: [],
      data: null,
      cif: null
    }
  },
  computed: {
    agenciesBaseTemp () {
      if (this.rowsSelected === 0 || this.rowsSelected > 1) return null
      if (this.selected[0].Organismos === undefined || this.selected[0].Organismos === null) return null
      return this.selected[0].Organismos.map(x => x)
    },
    accionesSedesAdminDynamic () {
      let accionesFinal = this.accionesSedesAdmin
      if (this.rowsSelected > 1) accionesFinal = accionesFinal.filter(x => x.id !== 1 && x.id !== 101)
      if (!this.hasModuleAgrupaciones) accionesFinal = accionesFinal.filter(x => x.id !== 12)
      return accionesFinal
    },
    hasModuleAgrupaciones () {
      return this.$store.getters['auth/hasModuleAgrupaciones']
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    labelBtnLinkPgns () {
      if (this.hasSelected) return this.$i18n.t('configurations.link_pgns_to_companies') + ' (Seleccionadas)'
      return this.$i18n.t('configurations.link_pgns_to_companies')
    },
    labelBtnLinkPgn () {
      return this.$i18n.t('configurations.link_pgn_to_companies_extend')
    },
    labelBtnUnlinkPgn () {
      return this.$i18n.t('configurations.unlink_pgn_to_companies_extend')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    }
  },
  created: function () {
    // this.kendo.navigate = this.role !== 'usuario'
    if (this.role !== 'Administrador') {
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'selected')
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'OrganismosExcluidos')
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'Agrupaciones')
      this.header.title = this.$i18n.t('app.locations')
    } 
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.data = await this.applyFilters()
  },
  methods: {
    onClicktoggleDialogLink () {
      if (this.hasSelected) this.doFeedback('Al aplicar se desvincularán las sedes no seleccionadas a las empresas seleccionadas', 'warning', 5 * 1000)
      this.toggleDialogLink()
    },
    toggleDialogLink: function () {
      this.linkToCompaniesDialog = !this.linkToCompaniesDialog
    },
    toggleDialogLinkPgn: function () {
      this.linkPgnToCompaniesDialog = !this.linkPgnToCompaniesDialog
    },
    toggleDialogUnlinkPgn: function () {
      this.unlinkPgnToCompaniesDialog = !this.unlinkPgnToCompaniesDialog
    },
    applyLinkCompaniesHandler: async function (companies) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const response = await updateCompaniesFromValoresDefecto(
          { 
            idPGNs: this.hasSelected ? this.selected.map(x => x.IdPGN) : null,
            idCifEmpresas: companies
          }
        )
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Empresas actualizadas correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.toggleDialogLink()
        this.$store.commit('setIsLoading', false)
      }
    },
    applyLinkPgnCompaniesHandler: async function (companies) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const response = await linkPgnToCompaniesFromValoresDefecto(
          { 
            idCliente: this.$route.params.id,
            idPGNs: this.selected.map(x => x.IdPGN),
            idCifEmpresas: companies
          }
        )
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Empresas actualizadas correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.toggleDialogLinkPgn()
        this.$store.commit('setIsLoading', false)
      }
    },
    applyUnlinkPgnCompaniesHandler: async function (companies) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const response = await unlinkPgnToCompaniesFromValoresDefecto(
          { 
            idCliente: this.$route.params.id,
            idPGN: this.selected.map(x => x.IdPGN)[0],
            idCifEmpresas: companies
          }
        )
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Empresas actualizadas correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.toggleDialogUnlinkPgn()
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleExcludeAgenciesDialogs: function () {
      this.excludeAgenciesDialog = !this.excludeAgenciesDialog
    },
    applyExcludeAgenciesHandler: async function (agencies) {
      await this.excludeAgenciesHandler(agencies)
      this.applyFilters()
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    openPath: function (event) {
      // this.$router.push({ name: 'configurations/locations/details', params: { location_id: event.dataItem.id } })
    },
    setWhatShow: function () {
      this.showAllRows = !this.showAllRows
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        Codigo: data.Codigo ? data.Codigo.value : null,
        Nombre: data.Nombre ? data.Nombre.value : null,
        URL: data.URL ? data.URL.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.IdPGN)
        payload.listaIDs = selectedIDs
      }
      try {
        let response
        if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
          response = await getSedesExcel(payload, params)
        } else {
          response = await getValoresDefectoByClientExcel(payload, params)
        }
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'sedes.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      // console.log('sortChange => sort', e)
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.skip,
        take: this.take,
        sort: this.sort,
        group: this.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    applyFilters: async function (eventData) {
      try {
        const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
        try {
          const params = {
            Codigo: data.Codigo ? data.Codigo.value : null,
            Nombre: data.Nombre ? data.Nombre.value : null,
            URL: data.URL ? data.URL.value : null,
            nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
          }
          const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
          this.data = await this.getItemsData(objOrder, params)
        } catch (error) {
          this.$store.commit('setIsLoading', false)
          this.doFeedback(this.$i18n.t('feedback.error.general'))
        }
      } catch (error) {
        this.doFeedback()
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      res.respuesta.forEach(x => {
        if (x.OrganismosExcluidos !== null) {
          x.Organismos = x.OrganismosExcluidos.map(y => y)
          x.OrganismosExcluidos = x.OrganismosExcluidos.map(y => y.Nombre)
        }
      })
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters

      }
      let data
      if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
        data = await getSedesPag(objOrder, params)
      } else {
        data = await getValoresDefectoByClientPag(objOrder, params)
      }
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    excludeAgenciesHandler: async function (agencies) {
      try {
        this.$store.commit('setIsLoading', true)
        const idPGN = this.selected[0].IdPGN
        const payload = { 
          idPGN, 
          idOrganismos: agencies
        }
        const response = await updateAgenciesExclusions(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.toggleExcludeAgenciesDialogs()
      }
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.id === 1) { 
        this.toggleExcludeAgenciesDialogs()
      } else if (this.selectedAction.id === 12) { 
        this.toggleModalGrouping()
      } else if (this.selectedAction.id === 100) { // Vincular a empresas a seleccionar
        this.toggleDialogLinkPgn()
      } else if (this.selectedAction.id === 101) { // Desvincular a empresas a seleccionar
        this.toggleDialogUnlinkPgn()
      } else {
        this.doFeedback('Acción no disponible actualmente', 'info')
      }
    },
    toggleModalGrouping () {
      this.showModalGrouping = !this.showModalGrouping
    },
    applyModalGrouping: async function (nombre) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Nombre: nombre, idPGNs: [], idCliente: this.$route.params.id }
        const selected = this.selected
        selected.forEach((s) => {
          payload.idPGNs.push(s.IdPGN)
        })
        const response = await linkGroupingLocationsName(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.toggleModalGrouping()
          await this.applyFilters()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
